module.exports = __webpack_public_path__ + "static/img/home_vid.bb3c894.png";


//////////////////
// WEBPACK FOOTER
// ./static/kfit/home_vid.png
// module id = 9+f/
// module chunks = 1